let domain;

if (process.env.NODE_ENV == 'production') {
	// 生产环境
	domain = "/api/";
} else {
	// 开发环境
	domain = "http://localhost:8081/api/";
}

export default {
	domain: domain
};
